import styled, { css } from "styled-components";

export default {
  Wrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 40px;
    padding: 40px;
    background-color: ${({ theme }) => theme.color.white};
    border-radius: 16px;
  `,
  AreaDiv: styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;

    & > h2 {
      ${({ theme }) => theme.font.small_bold};
    }
  `,
  QualAreaDiv: styled.div`
    align-self: flex-start;
    display: flex;
    flex-direction: column;
    

    & > h2 {
      ${({ theme }) => theme.font.small_bold};
      margin-bottom: 16px;
    }

    ._select {
      flex-grow: 1;
      padding: 8px 16px;
    }

    ._selectArea{
        display: flex;
        gap: 8px;

    }
  `,
  "TableDiv": styled.div`
    display: flex;
    flex-wrap: wrap;
    border: 1px solid ${({ theme }) => theme.color.grey2};
    width: 500px;
    margin-bottom: -1px;
  `,

  "TableElement": styled.div`
    flex-basis: 50%;
    flex-grow: 1;
    display: flex;
    

    & > h2 {
      display: flex;
      align-items: center;
      width: 200px;
      min-width: 200px;
      padding: 8px 16px;
      background-color: ${({ theme }) => theme.color.grey1};
      ${({ theme }) => theme.font.extra_small_bold};
    }

    & > p {
      display: flex;
      align-items: center;
      flex-grow: 1;
      ${({ theme }) => theme.font.extra_small};
      padding: 8px 16px;
    }
  `,

  LogoImg: styled.img`
    height: 180px;
  `,

  TabDiv: styled.div`
    display: flex;
    gap: 16px;
  `,
  Tab: styled.button`
    ${({ theme }) => theme.font.small_bold};

    ${({ $selected }) =>
      $selected &&
      css`
        ${({ theme }) => theme.font.small_bold};
        color: ${({ theme }) => theme.color.major};
      `}
  `,
};
